import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Typography } from 'antd';

import AiIcon from '../../../../../components/AiIcon';

import { useHomeMessageId } from '../../../hooks/useHomeMessageId';
import { useHomeAuthModal } from '../HomeAuthModalContext';
import InfoList from '../InfoList';

const { Title, Paragraph } = Typography;
const integrationPng = '/home/assets/integration.png';

const integrationItems = [
  'readyIntegration.item.signal',
  'readyIntegration.item.networks',
];

const IntegrationSection = () => {
  const { openRegister } = useHomeAuthModal();
  const homeMessageId = useHomeMessageId();

  return (
    <section className="home-page__split-section home-page__split-section--integration">
      <div className="home-page__split-copy">
        <div className="home-page__section-frame">
          <Title level={2}>
            <FormattedMessage id={homeMessageId('readyIntegration.title')} />
          </Title>
          <Paragraph>
            <FormattedMessage
              id={homeMessageId('readyIntegration.text')}
              values={{
                platforms: (chunks) => (
                  <span className="home-page__platform-names">{chunks}</span>
                ),
              }}
            />
          </Paragraph>
          <InfoList items={integrationItems.map((key) => homeMessageId(key))} />
          <Button
            type="primary"
            className="btn-gradient btn-gradient-lg"
            onClick={openRegister}
          >
            <FormattedMessage id={homeMessageId('button.watchVideo')} />
            <AiIcon name="play" />
          </Button>
          <Paragraph className="home-page__note">
            <FormattedMessage
              id={homeMessageId('readyIntegration.videoText')}
            />
          </Paragraph>
        </div>
      </div>
      <div
        className="home-page__cube-visual"
        style={{
          backgroundImage: `url(${integrationPng})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        }}
      />
    </section>
  );
};

export default IntegrationSection;
